<template>
  <LabelBadge :label="config.label" :color="config.color" :icon="config.icon" size="small" />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import LabelBadge from '@/components/designSystem/Badges/LabelBadge.vue'

import { STATUS_CONFIG } from '../constants'
import type { PostStationStatus } from '../types'

const props = defineProps<{
  status: PostStationStatus
}>()

const config = computed(() => STATUS_CONFIG[props.status])
</script>
